import React from 'react';
import  LoginSSO  from './LoginSSO';
import { LogInMail } from './LogInMail';
import { LuxTrust } from './LuxTrust';
import './Home.css';
import Loader from './Loader';


export const Home = (props) => {

    if (props.authorities === '') {
        return <Loader loading={true} />
    } else if (props.authorities === "ROLE_TWO_FACTOR_AUTHENTICATION_ENABLED") {
        if (props.isLuxTrust !== '') {
    return (
      <div>
        {props.isLuxTrust === 'true' ? (
            <LuxTrust />
                ) : (<LogInMail />)
        }
      </div>
    )
  } else {
            return <Loader />
        }
    } else {
    return (
            <LoginSSO />
    )
  }
};



// WEBPACK FOOTER //
// ./src/main/resources/js/components/Home.js